<div class="scroll">
  <div class="me-2">
    <div role="grid" class="datepicker-table" #datepickerTableRef>
      <div role="presentation">
        <div role="rowgroup">
          @for (yearRow of yearArray; track yearRow) {
            <tr role="row" class="datepicker-tablerow">
              @for (year of yearRow; track year) {
                <button
                  type="button"
                  class="datepicker-tablecell"
                  [class.selected]="year === initialYear"
                  [attr.aria-selected]="year === initialYear"
                  [attr.disabled]="
                    year > maxYear || year < minYear ? '' : undefined
                  "
                  [attr.id]="
                    year > maxYear || year < minYear
                      ? undefined
                      : 'year-' + year
                  "
                  (click)="selectYear(year)"
                  tabindex="-1"
                  role="gridcell"
                >
                  {{ year }}
                </button>
              }
            </tr>
          }
        </div>
      </div>
    </div>
  </div>
</div>
